import type { News, ServerNews } from './types';

export const newsAdapter = {
  toClient: (serverNews: ServerNews): News => {
    const { _id, title, label, priority, image, custom } = serverNews;

    return {
      id: _id,
      title,
      image: image ? (image.startsWith('http') ? image : `https://${image}`) : '',
      category: label,
      priority,
      links: custom.links,
      isPinned: custom.isPinned,
    };
  },
};
